module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp23_3009.ad8fd764.png";